import { Avatar as AntdAvatar } from 'antd'
import type { AvatarProps } from 'antd'

import styles from './styles.scss'

export function Avatar({ className, ...props }: AvatarProps) {
  return <AntdAvatar className={[className, styles.avatar].join(' ')} {...props} />
}
